// Cart drawer checkout upsell — when the cart holds exactly one product at
// quantity 1 in a size that has a bigger size available (12 oz -> 2 lb,
// 2 lb -> 5 lb), intercept the checkout click and offer the size-up,
// framed honestly as "less per ounce" using our own real prices — not a
// manufactured discount. Declining (or anything not eligible) proceeds to
// checkout exactly as before.
(function () {
  var SIZE_OZ = { '12 oz': 12, '16 oz': 16, '2 lb': 32, '5 lb': 80 };
  var UPGRADE_MAP = { '16 oz': '2 lb' };
  var bypass = false;

  function findSizeOption(item) {
    var match = (item.options_with_values || []).find(function (o) {
      return SIZE_OZ.hasOwnProperty(o.value);
    });
    return match ? match.value : null;
  }

  function findTargetVariant(product, item, targetSizeValue) {
    var optionIndex = -1;
    for (var i = 0; i < item.options_with_values.length; i++) {
      if (SIZE_OZ.hasOwnProperty(item.options_with_values[i].value)) {
        optionIndex = i;
        break;
      }
    }
    if (optionIndex === -1) return null;

    return product.variants.find(function (v) {
      for (var i = 0; i < v.options.length; i++) {
        if (i === optionIndex) {
          if (v.options[i] !== targetSizeValue) return false;
        } else if (v.options[i] !== item.options_with_values[i].value) {
          return false;
        }
      }
      return true;
    });
  }

  // Strip HTML and take roughly the first 3 sentences of a description.
  function shortDescription(html) {
    var text = (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    var sentences = text.match(/[^.!?]+[.!?]+/g) || [text];
    return sentences.slice(0, 2).join(' ').trim();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function buildModal(opts, onSwap, onContinue) {
    var overlay = document.createElement('div');
    overlay.className = 'rv-upsell-overlay';
    overlay.innerHTML =
      '<div class="rv-upsell-modal">' +
      '<button type="button" class="rv-upsell-close" aria-label="Close">&times;</button>' +
      '<h2 class="rv-upsell-title">Wait! Claim your <span class="rv-upsell-title-price">' +
      formatMoney(opts.savings) +
      '</span> bulk discount!</h2>' +
      '<div class="rv-upsell-columns">' +
      (opts.imageUrl
        ? '<div class="rv-upsell-media"><img src="' +
          opts.imageUrl +
          '" alt="' +
          opts.toSize +
          ' bag" width="260" height="260"></div>'
        : '') +
      '<div class="rv-upsell-content">' +
      '<h3 class="rv-upsell-product-title">' +
      opts.productTitle +
      '</h3>' +
      '<p class="rv-upsell-desc">' +
      opts.description +
      '</p>' +
      '<div class="rv-upsell-price-row">' +
      '<span class="rv-upsell-price-was">' +
      formatMoney(opts.equivalentPrice) +
      '</span>' +
      '<span class="rv-upsell-price-now">' +
      formatMoney(opts.actualPrice) +
      '</span>' +
      '</div>' +
      '<div class="rv-upsell-actions">' +
      '<button type="button" class="rv-upsell-swap">Upgrade &amp; save ' +
      formatMoney(opts.savings) +
      '</button>' +
      '<button type="button" class="rv-upsell-continue">Decline this offer</button>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    function remove() {
      overlay.remove();
    }

    overlay.querySelector('.rv-upsell-close').addEventListener('click', function () {
      remove();
      onContinue();
    });
    overlay.querySelector('.rv-upsell-continue').addEventListener('click', function () {
      remove();
      onContinue();
    });
    overlay.querySelector('.rv-upsell-swap').addEventListener('click', function () {
      remove();
      onSwap();
    });
  }

  function goToCheckout() {
    bypass = true;
    var form = document.getElementById('CartDrawer-Form');
    var btn = document.getElementById('CartDrawer-Checkout');
    if (form && btn && form.requestSubmit) {
      form.requestSubmit(btn);
    } else {
      window.location.href = '/checkout';
    }
  }

  function swapVariant(targetVariantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: 1, quantity: 0 }),
    })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: targetVariantId, quantity: 1 }] }),
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        window.location.href = '/checkout';
      });
  }

  function maybeShowUpsell(onProceed) {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart.items.length !== 1) return onProceed();
        var item = cart.items[0];
        if (item.quantity !== 1) return onProceed();
        // Subscribers already got a real discount for committing to a plan —
        // don't layer a size-up prompt on top, and avoid the risk of
        // silently dropping their subscription on swap.
        if (item.selling_plan_allocation) return onProceed();

        var currentSize = findSizeOption(item);
        if (!currentSize || !UPGRADE_MAP[currentSize]) return onProceed();
        var targetSize = UPGRADE_MAP[currentSize];

        fetch('/products/' + item.handle + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (product) {
            var targetVariant = findTargetVariant(product, item, targetSize);
            if (!targetVariant) return onProceed();

            // Equivalent price = what buying enough of the current (smaller)
            // size to match the target's ounces would cost, at that same
            // per-ounce rate. That's the "crossed out" comparison price —
            // real math, not an inflated reference price.
            var currentPerOz = item.price / SIZE_OZ[currentSize];
            var targetPerOz = targetVariant.price / SIZE_OZ[targetSize];
            var equivalentPrice = Math.round(currentPerOz * SIZE_OZ[targetSize]);
            var actualPrice = targetVariant.price;
            var savings = equivalentPrice - actualPrice;
            if (savings < 100) return onProceed(); // less than $1 saved isn't worth the interruption

            var imageUrl =
              (targetVariant.featured_image && targetVariant.featured_image.src) ||
              (product.featured_image ? product.featured_image : product.images[0]);

            // Value copy — computed live per product, no fake bonus math:
            // how many full "current size" bags fit inside the bigger bag,
            // and how much is left over beyond that (the genuinely free
            // bonus ounces). When the sizes divide evenly (e.g. 16oz->2lb
            // is exactly 2x) there's no leftover to claim, so that case
            // gets its own honest framing instead of inventing a bonus.
            var rawMultiple = SIZE_OZ[targetSize] / SIZE_OZ[currentSize];
            var ozMultiple = Math.round(rawMultiple * 10) / 10;
            if (ozMultiple % 1 === 0) ozMultiple = ozMultiple.toFixed(0);
            var fullBags = Math.floor(rawMultiple);
            var bonusOz = SIZE_OZ[targetSize] - fullBags * SIZE_OZ[currentSize];

            var valueDescription;
            if (bonusOz > 0) {
              valueDescription =
                'Upgrade your ' +
                currentSize +
                ' bag to ' +
                targetSize +
                ' and get the last <strong>' +
                bonusOz +
                ' oz free</strong>.';
            } else {
              valueDescription =
                'Upgrade your ' +
                currentSize +
                ' bag to the ' +
                targetSize +
                ' bag and get <strong>' +
                ozMultiple +
                'x the coffee</strong> for less.';
            }

            var pct = Math.round((savings / equivalentPrice) * 100);

            buildModal(
              {
                fromSize: currentSize,
                toSize: targetSize,
                imageUrl: imageUrl,
                productTitle: product.title,
                description: valueDescription,
                equivalentPrice: equivalentPrice,
                actualPrice: actualPrice,
                currentPrice: item.price,
                pct: pct,
                savings: savings,
              },
              function () {
                swapVariant(targetVariant.id);
              },
              onProceed
            );
          })
          .catch(onProceed);
      })
      .catch(onProceed);
  }

  // Delegate at the document level, not on the form node itself — Dawn's
  // own cart JS fully replaces the drawer's inner HTML (including the
  // <form>) on every cart update, which would silently orphan a listener
  // attached directly to that form at page load.
  document.addEventListener(
    'submit',
    function (e) {
      var submitter = e.submitter;
      if (!submitter || submitter.id !== 'CartDrawer-Checkout') return;
      if (bypass) {
        bypass = false;
        return;
      }
      e.preventDefault();
      maybeShowUpsell(goToCheckout);
    },
    true
  );
})();

// Move breadcrumbs (mobile only) to sit just above the product title, below
// the gallery image — instead of their default spot at the very top of the
// page. Restores them to their original spot if the viewport is desktop-
// sized, so this never leaks into the desktop layout.
(function () {
  var originalParent = null;
  var originalNextSibling = null;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function moveBreadcrumbs() {
    var crumbs = document.querySelector('.breadcrumbs');
    var title = document.querySelector('.product__title');
    if (!crumbs || !title) return;

    if (isMobile()) {
      if (crumbs.dataset.rvMoved) return;
      originalParent = crumbs.parentNode;
      originalNextSibling = crumbs.nextSibling;
      crumbs.dataset.rvMoved = '1';
      crumbs.classList.add('rv-breadcrumbs-moved');
      title.parentNode.insertBefore(crumbs, title);
    } else if (crumbs.dataset.rvMoved && originalParent) {
      crumbs.dataset.rvMoved = '';
      crumbs.classList.remove('rv-breadcrumbs-moved');
      originalParent.insertBefore(crumbs, originalNextSibling);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    moveBreadcrumbs();
    setTimeout(moveBreadcrumbs, 500);
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(moveBreadcrumbs, 150);
  });
})();

// Appstle tooltip: switch from hover to click
(function () {
  function fixTooltip() {
    var icon = document.querySelector('[data-appstle-icon]');
    var tooltip = document.querySelector('.appstle_tooltip');
    if (!icon || !tooltip) return;

    tooltip.style.setProperty('display', 'none', 'important');
    icon.style.cursor = 'pointer';

    var open = false;
    icon.addEventListener('click', function (e) {
      e.stopPropagation();
      open = !open;
      tooltip.style.setProperty('display', open ? 'block' : 'none', 'important');
    });

    document.addEventListener('click', function () {
      open = false;
      tooltip.style.setProperty('display', 'none', 'important');
    });

    var parent = icon.closest('.appstle-tootltip-parent');
    if (parent) {
      parent.addEventListener('mouseover', function (e) {
        if (!icon.contains(e.target)) {
          tooltip.style.setProperty('display', 'none', 'important');
        }
      }, true);
    }
  }
  setTimeout(fixTooltip, 1000);
  setTimeout(fixTooltip, 2000);
})();

// Mobile gallery scroll hints — small "‹"/"›" buttons that step the image
// row one slide per tap. Each side only shows when there's actually more to
// scroll toward, updating live as the user swipes or taps.
(function () {
  function initMobileHint() {
    var wrapper = document.querySelector('.product__media-wrapper');
    var list = document.querySelector('.product__media-list');
    if (!wrapper || !list || wrapper.dataset.hintInit) return;
    wrapper.dataset.hintInit = '1';

    function makeButton(direction) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rv-mobile-scroll-hint rv-mobile-scroll-hint--' + direction;
      btn.setAttribute('aria-label', direction === 'next' ? 'Scroll to next image' : 'Scroll to previous image');
      btn.textContent = direction === 'next' ? '›' : '‹';
      btn.addEventListener('click', function () {
        var slide = list.querySelector('.product__media-item');
        var step = slide ? slide.getBoundingClientRect().width : list.clientWidth * 0.8;
        list.scrollBy({ left: direction === 'next' ? step : -step, behavior: 'smooth' });
      });
      wrapper.appendChild(btn);
      return btn;
    }

    var prevBtn = makeButton('prev');
    var nextBtn = makeButton('next');

    function updateVisibility() {
      var maxScroll = list.scrollWidth - list.clientWidth;
      prevBtn.hidden = list.scrollLeft <= 4;
      nextBtn.hidden = list.scrollLeft >= maxScroll - 4;
    }

    var ticking = false;
    list.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateVisibility();
          ticking = false;
        });
      },
      { passive: true }
    );

    updateVisibility();
  }

  document.addEventListener('DOMContentLoaded', initMobileHint);
  setTimeout(initMobileHint, 500);
})();

// Click-and-drag scrolling for the product gallery — real mice only. Touch
// devices already swipe natively; synthetic mouse events from touch would
// fight with that and make the gallery appear stuck, so we bail out early
// on any touch/coarse-pointer device.
(function () {
  function initDragScroll() {
    if (window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches) {
      return;
    }

    var list = document.querySelector('.product__media-list');
    if (!list || list.dataset.dragInit) return;
    list.dataset.dragInit = '1';

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScrollLeft = 0;

    list.addEventListener('mousedown', function (e) {
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScrollLeft = list.scrollLeft;
      list.classList.add('rv-dragging');
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var delta = e.pageX - startX;
      if (Math.abs(delta) > 4) moved = true;
      list.scrollLeft = startScrollLeft - delta;
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      list.classList.remove('rv-dragging');
    });

    // If the drag actually moved the gallery, swallow the click that
    // follows so it doesn't accidentally open the zoom/lightbox.
    list.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', initDragScroll);
  setTimeout(initDragScroll, 500);
})();

// Product gallery nav arrows (prev/next, hide zoom)
(function () {
  function initGalleryArrows() {
    if (window.innerWidth < 750) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.dataset.arrowsInit) return;
    gallery.dataset.arrowsInit = '1';

    var sliderComponent = gallery.querySelector('slider-component');
    var list = gallery.querySelector('.product__media-list');
    if (!sliderComponent || !list) return;

    sliderComponent.style.position = 'relative';

    function makeSVG(isNext) {
      return '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">'
        + (isNext ? '<polyline points="9 18 15 12 9 6"/>' : '<polyline points="15 18 9 12 15 6"/>')
        + '</svg>';
    }

    var prev = document.createElement('button');
    prev.className = 'gallery-nav-arrow gallery-nav-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = makeSVG(false);

    var next = document.createElement('button');
    next.className = 'gallery-nav-arrow gallery-nav-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = makeSVG(true);

    sliderComponent.appendChild(prev);
    sliderComponent.appendChild(next);

    function getSlides() {
      return Array.from(list.querySelectorAll('.product__media-item'));
    }

    function getActiveIndex() {
      var slides = getSlides();
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    var animating = false;

    function goTo(index) {
      if (window.innerWidth < 750) return;
      if (animating) return;
      var slides = getSlides();
      if (index < 0 || index >= slides.length) return;
      var currentIndex = getActiveIndex();
      if (index === currentIndex) return;

      var direction = index > currentIndex ? 1 : -1;
      var current = slides[currentIndex];
      var next = slides[index];

      animating = true;

      // Prime the incoming slide off-screen
      next.style.display = 'block';
      next.style.position = 'absolute';
      next.style.top = '0';
      next.style.left = '0';
      next.style.width = '100%';
      next.style.transform = direction > 0 ? 'translateX(100%)' : 'translateX(-100%)';
      next.style.opacity = '0';

      // Force reflow
      next.getBoundingClientRect();

      // Animate both
      current.style.transition = 'transform 0.4s cubic-bezier(0.4,0,0.2,1), opacity 0.4s ease';
      next.style.transition = 'transform 0.4s cubic-bezier(0.4,0,0.2,1), opacity 0.4s ease';

      current.style.transform = direction > 0 ? 'translateX(-100%)' : 'translateX(100%)';
      current.style.opacity = '0';
      next.style.transform = 'translateX(0)';
      next.style.opacity = '1';

      setTimeout(function() {
        // Reset inline styles and let Dawn take over
        current.style.cssText = '';
        next.style.cssText = '';
        gallery.setActiveMedia(next.dataset.mediaId, false);
        animating = false;
        updateArrows(index, slides.length);
      }, 420);
    }

    function updateArrows(index, total) {
      prev.classList.toggle('is-visible', index > 0);
      next.classList.toggle('is-visible', index < total - 1);
    }

    prev.addEventListener('click', function (e) {
      e.stopPropagation();
      goTo(getActiveIndex() - 1);
    });

    next.addEventListener('click', function (e) {
      e.stopPropagation();
      goTo(getActiveIndex() + 1);
    });

    var observer = new MutationObserver(function () {
      updateArrows(getActiveIndex(), getSlides().length);
    });
    observer.observe(list, { attributes: true, subtree: true, attributeFilter: ['class'] });

    var slides = getSlides();
    if (slides.length <= 1) {
      prev.style.display = 'none';
      next.style.display = 'none';
      return;
    }
    updateArrows(0, slides.length);
  }

  document.addEventListener('DOMContentLoaded', initGalleryArrows);
  setTimeout(initGalleryArrows, 500);
})();



// Fly-to-cart animation
(function () {
  // Set by the sticky ATC bar right before it forwards its click to the real
  // (currently off-screen) submit button, so the flying element starts from
  // where the user actually clicked instead of the — likely also off-screen —
  // product image.
  window.__flyToCartOrigin = null;

  function flyToCart() {
    // Find the visible cart icon (desktop header or mobile header)
    var cartIcon = Array.from(document.querySelectorAll('#cart-icon-bubble, .header__icon--cart'))
      .find(function (el) {
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.top >= 0 && r.top < window.innerHeight;
      });
    if (!cartIcon) return;

    var origin = window.__flyToCartOrigin;
    window.__flyToCartOrigin = null;

    var cartRect = cartIcon.getBoundingClientRect();
    var img = document.querySelector('.product__media-item.is-active img') ||
              document.querySelector('.product__media-item img');

    var startLeft, startTop, startW, startH, cloneSrc;

    if (origin) {
      // Clicked from the sticky bar — start from the sticky button itself,
      // which is the only visible element at that point in the scroll.
      var originRect = origin.getBoundingClientRect();
      startLeft = originRect.left + originRect.width / 2 - 15;
      startTop = originRect.top + originRect.height / 2 - 15;
      startW = 30;
      startH = 30;
      cloneSrc = img ? (img.currentSrc || img.src) : null;
    } else {
      if (!img) return;
      var imgRect = img.getBoundingClientRect();
      // Start position: center of image if visible, else top-center of viewport
      startLeft = imgRect.width > 0 && imgRect.top > -imgRect.height
        ? imgRect.left + imgRect.width * 0.3
        : window.innerWidth / 2 - 30;
      startTop = imgRect.width > 0 && imgRect.top > -imgRect.height
        ? imgRect.top + imgRect.height * 0.3
        : 80;
      startW = imgRect.width > 0 ? imgRect.width * 0.4 : 60;
      startH = imgRect.height > 0 ? imgRect.height * 0.4 : 60;
      cloneSrc = img.currentSrc || img.src;
    }

    var clone = cloneSrc ? document.createElement('img') : document.createElement('div');
    if (cloneSrc) clone.src = cloneSrc;
    clone.style.cssText = [
      'position:fixed',
      'z-index:9999',
      'border-radius:' + (cloneSrc ? '4px' : '50%'),
      'pointer-events:none',
      'width:' + startW + 'px',
      'height:' + startH + 'px',
      'left:' + startLeft + 'px',
      'top:' + startTop + 'px',
      'transition:all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      'opacity:1',
      'object-fit:cover',
      cloneSrc ? '' : 'background:#000',
    ].join(';');

    document.body.appendChild(clone);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.left = (cartRect.left + cartRect.width / 2 - 10) + 'px';
        clone.style.top = (cartRect.top + cartRect.height / 2 - 10) + 'px';
        clone.style.width = '20px';
        clone.style.height = '20px';
        clone.style.opacity = '0';
      });
    });

    setTimeout(function () { clone.remove(); }, 750);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('.product-form__submit');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      flyToCart();
    });
  });
})();

// Move quantity box into product-form__buttons for side-by-side layout
(function () {
  function moveQty() {
    var qtyBlock = document.querySelector('[id^="Quantity-Form-template"]');
    var buttons = document.querySelector('.product-form__buttons');
    if (!qtyBlock || !buttons) return;
    if (buttons.querySelector('.rv-qty-moved')) return; // already moved

    var qtyInput = qtyBlock.querySelector('quantity-input');
    if (!qtyInput) return;

    // Clone the quantity-input into a wrapper and prepend to buttons
    var wrapper = document.createElement('div');
    wrapper.className = 'rv-qty-moved';
    wrapper.appendChild(qtyInput.cloneNode(true));
    buttons.insertBefore(wrapper, buttons.firstChild);

    // Hide the original block
    qtyBlock.classList.add('rv-qty-original-hidden');
  }

  // Run immediately — the quantity block and buy-buttons are both already
  // in the DOM at parse time (unlike Appstle's async widget), so there's no
  // real reason to wait. The retries are just a safety net.
  document.addEventListener('DOMContentLoaded', function () {
    moveQty();
    setTimeout(moveQty, 500);
    setTimeout(moveQty, 1500);
  });

  // Re-run after variant change (Dawn pubsub)
  document.addEventListener('variant-change', function () {
    setTimeout(moveQty, 300);
  });
})();

// Preload all product images for instant variant switching
document.addEventListener('DOMContentLoaded', function () {
  var images = document.querySelectorAll('.product__media-list img[srcset]');
  images.forEach(function (img) {
    var srcset = img.getAttribute('srcset');
    if (!srcset) return;
    var srcs = srcset.split(',').map(function (s) { return s.trim().split(' ')[0]; });
    // Preload the medium-size version (around 600-800px)
    var mid = srcs.find(function(s) { return s.includes('width=600') || s.includes('width=713'); });
    if (mid) {
      var link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = mid;
      document.head.appendChild(link);
    }
  });
});

// Strip the trailing currency code (" USD") from the main product price
// only — never touches Appstle's widget or the floating bar's price.
(function () {
  function stripCurrencyCode() {
    document.querySelectorAll('[id^="price-"] .price-item').forEach(function (el) {
      if (el.closest('s')) return; // leave the (hidden) compare price alone
      var original = el.textContent;
      var cleaned = original.replace(/\s*\b[A-Z]{3}\b\s*$/, '').trim();
      // Only write back if it actually changes — avoids re-triggering the
      // observer below for no reason (and any accidental self-loop).
      if (cleaned !== original.trim()) {
        el.textContent = cleaned;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    stripCurrencyCode();

    // Re-run after Dawn re-renders the price block on variant change.
    // Scoped to just the price container(s), not document.body.
    document.querySelectorAll('[id^="price-"]').forEach(function (container) {
      new MutationObserver(stripCurrencyCode).observe(container, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  });
})();

// Strip the trailing currency code (" USD") from the cart drawer subtotal.
(function () {
  function stripDrawerCurrency() {
    document.querySelectorAll('.totals__total-value').forEach(function (el) {
      var original = el.textContent;
      var cleaned = original.replace(/\s*\b[A-Z]{3}\b\s*$/, '').trim();
      if (cleaned !== original.trim()) {
        el.textContent = cleaned;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    stripDrawerCurrency();

    // The drawer re-renders after cart changes — #CartDrawer itself is a
    // stable container that survives those updates, so observe that rather
    // than document.body.
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      new MutationObserver(stripDrawerCurrency).observe(drawer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  });
})();

document.addEventListener('DOMContentLoaded', function () {
    // Select all carousels
    const carousels = document.querySelectorAll('.carousel');

    carousels.forEach((carousel) => {
        let currentIndex = 0;
        const itemsShown = 3;
        const items = carousel.querySelectorAll('.carousel-item');
        const totalItems = items.length;
        const prevButton = carousel.querySelector('.prev');
        const nextButton = carousel.querySelector('.next');

        const track = carousel.querySelector('.carousel-track');
        const itemWidth = 100 / itemsShown;

        // Set each item's width based on items shown
        items.forEach(item => {
            item.style.flex = `0 0 ${itemWidth}%`;
        });

        function showSlide(index) {
            const maxIndex = totalItems - itemsShown;

            if (index > maxIndex) currentIndex = 0;
            if (index < 0) currentIndex = maxIndex;

            const translateXPercent = (currentIndex * itemWidth);
            track.style.transform = `translateX(-${translateXPercent}%)`;
        }

        prevButton.addEventListener('click', () => {
            currentIndex++;
            showSlide(currentIndex);
        });

        nextButton.addEventListener('click', () => {
            currentIndex--;
            showSlide(currentIndex);
        });
    });
});
